import { ExecutionItem } from '../interfaces/changeRequest';
import { IMPLEMENTABLE_STATUSES } from '../services/changeRequestService';

export const getDisabledReason = (
  record: ExecutionItem,
  isImplementing: boolean
) => {
  if (isImplementing) {
    return 'Implementation is in progress.';
  }
  if (record.type === 'manual task') {
    return 'Manual tasks cannot be implemented automatically.';
  }
  if (!IMPLEMENTABLE_STATUSES.includes(record.status)) {
    return `"${record.status.toUpperCase()}" cannot be implemented. Only "PENDING", "INPUT NEEDED"  and "ERROR" statuses can be implemented.`;
  }
  return '';
};

export const generateChangeRequestName = (changeRequests: unknown[]) => {
  return `CR-${(changeRequests.length + 1).toString().padStart(4, '0')}`;
};
